import {Box, Divider, Flex, Heading, Image, ListItem, Spacer, UnorderedList, Tooltip} from '@chakra-ui/react';
import {Link} from 'react-router-dom';
import {ArrowUpIcon} from '@chakra-ui/icons'
import {FaFacebook, FaInstagram, FaLinkedin, FaYoutube} from 'react-icons/fa';
import React, {useEffect, useState} from 'react'
import {replaceurlbystore,replaceurlbycheckout,ShopifyStoreFrontAccessToken, ShopifyStoreLink} from "../../../GlobalVar";
import {scrollToTop} from "../../utils";
import MainlLogo from "../../../Logo/drillcut-SVG.svg";
import FooterImage from "../../../Logo/648372-footerlogo.svg";
import {useAppSettings} from "../../hooks/useAppSettings";

export const Footer = () => {
    const [footer_1, setFooter_1] = useState('');
    const [footer_2, setFooter_2] = useState('');
    const [footer_3, setFooter_3] = useState('');
    const [footer_4, setFooter_4] = useState('');
    const {data: generalData} = useAppSettings({
        page: "general"
    });

    useEffect(() => {
        getMenu();
    }, [])

    const getMenu = () => {
        const query = `{
        menu(handle: "footer-our-range-first") {
           items {
            title
            url
          }
        }
       }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data = response.json()
                Promise.all([data]).then((values) => {
                    // console.log(values,"live url");
                    setFooter_1(values[0]['data']['menu']['items']);
                });

            })
        const query_2 = `{
      menu(handle: "our-range-2-footer") {
         items {
          title
          url
        }
      }
     }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query_2, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data_2 = response.json()
                Promise.all([data_2]).then((values) => {
                    setFooter_2(values[0]['data']['menu']['items']);
                });

            })
        const query_3 = `{
    menu(handle: "left-menu") {
       items {
        title
        url
      }
    }
   }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query_3, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data = response.json()
                Promise.all([data]).then((values) => {
                    setFooter_3(values[0]['data']['menu']['items']);
                });

            })
        const query_4 = `{
  menu(handle: "right-menu") {
     items {
      title
      url
    }
  }
 }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query_4, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data = response.json()
                Promise.all([data]).then((values) => {
                    setFooter_4(values[0]['data']['menu']['items']);
                });

            })
    }

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setVisible(true)
        } else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    window.addEventListener('scroll', toggleVisible);
    return (<Box>
            <Flex onClick={scrollToTop} style={{display: visible ? 'flex' : 'none'}} className='arrow_top_bottom'>
                <ArrowUpIcon/>
            </Flex>
            <Box bg='#F2F2F2' position='relative'>
                <Box className='main_container'>

                    <Box>
                        <Box maxW='100%'>
                            <Flex p='30px 0' justifyContent={{base: 'space-between', md: 'normal'}}
                                  className="footer_logo_main">
                                <Box>
                                    <Link to='/' onClick={scrollToTop}>
                                        <Image
                                            loading='lazy'
                                            // width='100%'
                                            // height='241'
                                            htmlWidth='100%'
                                            htmlHeight='241'
                                            className="footer_logo_main_logo"
                                               src={MainlLogo}
                                               alt='logo'/>
                                    </Link>
                                </Box>
                                <Image loading='lazy' src={FooterImage}
                                       htmlWidth='100'
                                       htmlHeight='10'
                                       className="footer_job_done_logo" alt="logo"
                                       ml={{base: '0', md: '50px'}}/>
                            </Flex>
                        </Box>
                        <Box maxW='100%' p='40px 0 40px 0'>
                            <Flex className='footer_menu' flexDirection={{base: 'column', md: 'row'}}>
                                <Box w='100%' pb={{base: '10', md: '0'}}>
                                    <Flex fontSize='16px' textAlign='left' className='footer_menu-content'>
                                        <Box pr={{base: '0', md: '120px'}} className='footer_menu_content_contain'>
                                            <strong className='footer_menu_heading'>Our Range</strong>
                                            <UnorderedList listStyleType='none' m='0' className='menu_footer_mt'>
                                                {footer_1 && footer_1.map((menu, i) => {
                                                    return (
                                                        <ListItem key={menu.url + '-' + i}>
                                                            <Link onClick={scrollToTop}
                                                                  to={menu.url.replace(`${replaceurlbystore}`, '')}>{menu.title}</Link>
                                                        </ListItem>
                                                    )
                                                })}
                                            </UnorderedList>
                                        </Box>
                                        <Box>
                                            <UnorderedList listStyleType='none' pt='21.5px' m='0'
                                                           className='menu_footer_mt'>
                                                {footer_2 && footer_2.map((menu, i) => {
                                                    return (
                                                        <ListItem key={menu.url + '-' + i}>
                                                            <Link onClick={scrollToTop}
                                                                  to={menu.url.replace(`${replaceurlbystore}`, '')}>{menu.title}</Link>
                                                        </ListItem>
                                                    )
                                                })}
                                            </UnorderedList>
                                        </Box>
                                    </Flex>
                                </Box>
                                <Divider orientation='vertical' className='footer_divider'
                                         display={{base: 'none', md: 'block'}}/>
                                <Box w='100' className='footer_border' display={{base: 'block', md: 'block'}}></Box>
                                <Box w='100%' pt={{base: '10', md: '0'}}>
                                    <Flex fontSize='16px' textAlign='left'
                                          justifyContent={{base: 'space-between', md: 'normal'}}>
                                        <Box pr={{base: '0', md: '140px'}} className='footer_menu_content_contain'>
                                            <UnorderedList listStyleType='none' m='0'
                                                           className='menu_footer_mt footer_main_menu'>
                                                {footer_3 && footer_3.map((menu, i) => {
                                                    let menuUrl = menu.url;
                                                    if (menuUrl.includes(replaceurlbystore)) {
                                                        menuUrl = menuUrl.replace(`${replaceurlbystore}`, '')
                                                    }
                                                    return (
                                                        <ListItem key={menu.url + '-' + i}>
                                                            {menu.url.includes(replaceurlbystore) ?
                                                                <Link onClick={scrollToTop}
                                                                      to={menuUrl}>
                                                                    {menu.title}
                                                                </Link> :
                                                                <Tooltip label="opens in new tab" fontSize="md" placement='top'>
                                                                    <a href={menuUrl} target="_blank" rel="noopener noreferrer" aria-label={`${menu.title} (opens in new tab)`}>{menu.title}</a>
                                                                </Tooltip>}
                                                        </ListItem>
                                                    )
                                                })}
                                            </UnorderedList>
                                        </Box>
                                        <Box>
                                            <UnorderedList listStyleType='none' m='0'
                                                           className='menu_footer_mt footer_main_menu'>
                                                {footer_4 && footer_4.map((menu, i) => {
                                                    return (
                                                        <ListItem key={menu.url + '-' + i}>
                                                            <Link onClick={scrollToTop}
                                                                  to={menu.url.replace(`${replaceurlbystore}`, '')}>{menu.title}</Link>
                                                        </ListItem>
                                                    )
                                                })}
                                            </UnorderedList>
                                        </Box>
                                    </Flex>
                                </Box><Spacer/>
                                <Box w={{base: '100%', md: '27%'}} pt={{base: '10', md: '0'}}>
                                    <Box>
                                        <Heading as="p" className='footer_social_heading'
                                                 textAlign={{base: 'left', md: 'right'}} mb='3'>
                                            Follow Us
                                        </Heading>
                                        <UnorderedList className='footer_icons' m='0'>
                                            <ListItem ml='0 !important'><Tooltip label="opens in new tab" fontSize="md" placement='top'><a
                                                href={generalData?.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook (opens in new tab)"><FaFacebook/></a></Tooltip></ListItem>
                                            <ListItem><Tooltip label="opens in new tab" fontSize="md" placement='top'><a href={generalData?.instagram} rel="noopener noreferrer" target="_blank" aria-label="Instagram (opens in new tab)"><FaInstagram/></a></Tooltip></ListItem>
                                            <ListItem><Tooltip label="opens in new tab" fontSize="md" placement='top'><a href={generalData?.youtube} rel="noopener noreferrer" target="_blank" aria-label="Youtube (opens in new tab)"><FaYoutube/></a></Tooltip></ListItem>
                                            <ListItem><Tooltip label="opens in new tab" fontSize="md" placement='top'><a href={generalData?.linkedin} rel="noopener noreferrer" target="_blank" aria-label="LinkedIn (opens in new tab)"><FaLinkedin/></a></Tooltip></ListItem>
                                        </UnorderedList>
                                    </Box>
                                </Box>
                            </Flex>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box>
            </Box>

            <Box className='footer_bottom_section'>
                <Box className='full_width_Box'>
                    <Flex className='footer_bottom_section_content'>
                        <p className='footer_headings'>
                            <span>© DRILLCUT PTY LTD {new Date().getFullYear()} </span><span
                            className='split_icon_desktop'>|</span>                            
                            <Link to='/termsconditions' onClick={scrollToTop}> Terms & Conditions </Link><span
                            className='split_icon_desktop'>|</span>
                            <Link to='/privacy-policy' onClick={scrollToTop}> Privacy Policy </Link><span
                            className='split_icon_desktop'>|</span>
                            <Link to='/returns-policy' onClick={scrollToTop}> Returns Policy </Link>
                            <span className='split_icon_desktop'>|</span>
                            <a href='/sitemap.html' style={{marginLeft: "5px"}} target="_blank" rel="noopener noreferrer">Sitemap</a>                            
                        </p>
                        {/*<p className='footer_logo'>*/}
                        {/*    <button>Made by <Image src={footerBottomIcon} alt="FooterIcon"*/}
                        {/*                           className='footer_bottom_icon'/></button>*/}
                        {/*</p>*/}
                    </Flex>
                </Box>
            </Box>
        </Box>

    )
}